<template>
  <div
    :id="type + '-radar'"
  >
    <img
      class="position-absolute top-0 w-100"
      style="left: 0; right: 0; margin-left: auto; margin-right: auto;"
      :src="'/map/' + type + '/base.png'"
    >
    <img
      class="position-absolute top-0 w-100"
      style="left: 0; right: 0; margin-left: auto; margin-right: auto;"
      :src="'/map/' + type + '/radar/' + currentImg + '.png?bust=' + cacheBuster"
    >
    <span
      class="d-flex display-2 position-absolute top-0"
    >
      {{ times[currentImg + '.png'] }}
    </span>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AnimatedRadar',
  props: {
    type: {
      type: String,
      required: true,
    },
    cacheBuster: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentImg: 0,
      times: {},
    };
  },
  watch: {
    cacheBuster() {
      this.getTimes();
    },
  },
  mounted() {
    const vm = this;
    this.getTimes();
    setInterval(() => {
      vm.current();
    }, 500);
  },
  methods: {
    getTimes() {
      const vm = this;
      axios.get(`/api/map/radar/${vm.type}/times`)
        .then((response) => {
          vm.times = response.data;
        });
    },
    current() {
      if (this.currentImg === 11) {
        this.currentImg = 0;
      } else {
        this.currentImg++;
      }
    },
  },
};
</script>
